// src/App.jsx
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Home from "./pages/Home";
import ClientSignIn from "./pages/Client";   // 👈 aquí con C mayúscula, igual que el archivo
import MiPerfil from "./pages/MiPerfil";

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Inicio */}
        <Route path="/" element={<Home />} />

        {/* Acceso clientes (formulario de RUT) */}
        <Route path="/cliente" element={<ClientSignIn />} />

        {/* Perfil del cliente (usa ?rut=...) */}
        <Route path="/MiPerfil" element={<MiPerfil />} />

        {/* Cualquier ruta desconocida => manda al acceso de clientes */}
        <Route path="*" element={<Navigate to="/cliente" replace />} />
      </Routes>
    </Router>
  );
}
